



















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SalesReportMonthlySummary extends Vue {
  @Prop({ required: true }) monthly!: any;

  formatCurrency(value: any) {
    return value || value === 0 ? "￥" + parseInt(value).toLocaleString() : "";
  }

  isNegative(value: any) {
    return parseFloat(value) < 0;
  }

  get labels() {
    return this.monthly.map((s: any) => s.month);
  }

  get invoices() {
    return this.monthly.map((s: any) => s.invoice);
  }

  get purchases() {
    return this.monthly.map((s: any) => s.purchase);
  }

  get profits() {
    return this.monthly.map((s: any) => s.profit);
  }
}
